import { styled, Box } from "@mui/material";

export const TableRow = styled(Box)({
  height: "30px",
  display: "grid",
  gridTemplateColumns: "1fr 4fr 4fr 4fr",
  alignItems: "center",
  fontSize: "12px",
  color: "#000",
  fontWeight: 500,
  gap: 1,
  borderBottom: "1px solid #dcdddd",
  "&:nth-of-type(2n)": {
    background: "#fafafa",
  },
  "& div:first-of-type": {
    color: "#181D27",
    fontWeight: 500,
  },
});

export const TableCell = styled(Box)({
  display: "flex",
  justifyContent: "center",
  height: "100%",
  alignItems: "center",
});
